require('./Program.scss');

const b = require('app/www/libs/b')('program-controller');
const bContent = require('app/www/libs/b')('content');

const _get = require('lodash/get');
const _find = require('lodash/find');
const _chunk = require('lodash/chunk');

const React = require('react');
const PropTypes = require('prop-types');
const {connect} = require('react-redux');

const nextTick = require('app/www/libs/nextTick');

const {withReq} = require('app/www/components/contexts/Req');
const {withI18n} = require('app/www/components/contexts/I18n');
const {withExperiments} = require('app/www/components/contexts/Experiments');
const {isADBEnabled} = require('app/www/libs/aab');

const {getSchedule, updateSchedule} = require('app/www/actions/program');
const {getFavoriteChannels} = require('app/www/actions/channel');
const {getProvider} = require('app/www/actions/recommended');
const {
    update: updateReminders,
    fulfilled: fulfilledReminders,
} = require('app/www/actions/reminders');

const AdvManager = require('app/www/components/blocks/AdvManager/AdvManager');
const BreadCrumbs = require('app/www/components/blocks/BreadCrumbs/BreadCrumbs');
const Content = require('app/www/components/blocks/Content/Content');
const Global = require('app/www/components/blocks/Global/Global');
const ProgramDescription = require('app/www/components/blocks/ProgramDescription/ProgramDescription');
const ProgramDetails = require('app/www/components/blocks/ProgramDetails/ProgramDetails');
const ProgramEntryPoint = require('app/www/components/blocks/ProgramEntryPoint/ProgramEntryPoint');
const ProgramEpisodes = require('app/www/components/blocks/ProgramEpisodes/ProgramEpisodes');
const ProgramGallery = require('app/www/components/blocks/ProgramGallery/ProgramGallery');
const ProgramHeader_Complex = require('app/www/components/blocks/ProgramHeader/_Complex/ProgramHeader_Complex');
const ProgramHeader_Simple = require('app/www/components/blocks/ProgramHeader/_Simple/ProgramHeader_Simple');
const ProgramMultichannels = require('app/www/components/blocks/ProgramMultichannels/ProgramMultichannels');
const ProgramOthers = require('app/www/components/blocks/ProgramOthers/ProgramOthers');
const ProgramPersons = require('app/www/components/blocks/ProgramPersons/ProgramPersons');
const ProgramPosts = require('app/www/components/blocks/ProgramPosts/ProgramPosts');
const ProgramQuotes = require('app/www/components/blocks/ProgramQuotes/ProgramQuotes');
const ProgramStatistics = require('app/www/components/blocks/ProgramStatistics/ProgramStatistics');
const ResizeListener = require('app/www/components/blocks/ResizeListener/ResizeListener');
const Zen = require('app/www/components/blocks/Zen/Zen');
const Ua = require('app/www/components/blocks/Ua/Ua');

const {DESKTOP, TABLET, PHONE} = require('app/www/constants/devices');
const DESCRIPTION_LENGTH = 120;
const REMINDERS_CHUNK_SIZE = 5;
const SCROLL_OFFSET = 20;
const STAT_ID = 2;
const EXPERIMENT_ZEN = 'zen_channel_program';

class ProgramController extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = Object.assign({
            shortDescription: true,
            buttonDescription: false,
            recommendedRender: true, // Выставляемтся в false после получения пустого массива сеансов (getDerivedStateFromProps)
            recommendedLoading: true, // Необходимо при получении рекомендации проверить что блок надо удалять (getDerivedStateFromProps)
            selectedEpisode: null,
            showEpisodesModal: false,
            currentIndex: 0,
        }, Ua.displayWidth && (
            this._initialState
        ));

        this._isSerpApp = this.props.req.lib('urlBuilder').isSerpApp;

        this._onClickDescriptionButton = this._onClickDescriptionButton.bind(this);
        this._onEventFinished = this._onEventFinished.bind(this);
        this._onMoreEvents = this._onMoreEvents.bind(this);
        this._dispatchFulfilledReminders = this._dispatchFulfilledReminders.bind(this);
        this._onClickButtonEpisodes = this._onClickButtonEpisodes.bind(this);
        this._onClickButtonWatchEpisode = this._onClickButtonWatchEpisode.bind(this);
        this._onClickButtonBroadcasting = this._onClickButtonBroadcasting.bind(this);
        this._onClickButtonWatchOnline = this._onClickButtonWatchOnline.bind(this);
        this._onClickEpisode = this._onClickEpisode.bind(this);
        this._onResize = this._onResize.bind(this);
    }

    componentDidMount() {
        const {program} = this.props;
        const {programId, type} = program.meta;

        this.props.dispatchGetRecommended(programId, type.id);

        if (!this._isSerpApp) {
            const channelIds = program.schedules.map(schedule => schedule.channel.id);

            this.props.dispatchGetFavoriteChannels(channelIds);
            this._dispatchFulfilledReminders();
        }

        nextTick(() => {
            this.setState(this._initialState);
        });
    }

    static getDerivedStateFromProps(props, state) {
        const {events} = props.recommendedProvider;

        if (
            state.recommendedLoading &&
            events && events.length === 0
        ) {
            return {
                recommendedRender: false,
                recommendedLoading: false,
            };
        }

        return null;
    }

    render() {
        const {
            req,
            i18n,
            favoriteChannels,
        } = this.props;

        const {
            advKey,
            selectedEpisode,
            recommendedRender,
            showEpisodesModal,
            isTouchButtons,
            isLayoutColumnsSmall,
            isLayoutColumnsLarge,
        } = this.state;

        const {
            meta,
            gallery,
            schedules,
            entryPoint,
            episodes,
        } = this.props.program;

        let programHeaderEvent = null;
        let buttonBroadcastingProps = null;

        const programMultichannelsProps = {
            schedules: schedules.map((item, i) => {
                const firstEvent = item.channel.firstEvent;
                const startTime = firstEvent.startTime;
                const firstEventStartTime = startTime ? i18n.get('program-controller.start-time', {time: firstEvent.startTime}) : '';

                if (!programHeaderEvent) {
                    programHeaderEvent = `${firstEvent.channelTitle} · ${firstEvent.date} ${firstEventStartTime}`;
                }

                if (
                    firstEvent.isNow &&
                    item.channel.hasBroadcasting &&
                    !buttonBroadcastingProps
                ) {
                    buttonBroadcastingProps = {
                        channelId: item.channel.id,
                        familyId: item.channel.familyId,
                        programId: meta.programId,
                        streamChannel: item.channel.streamChannel,
                        transliteratedFamilyTitle: item.channel.transliteratedFamilyTitle,
                    };
                }

                return {
                    channel: Object.assign({}, item.channel, {
                        showIndicator: true,
                        mods: {
                            multichannel: true,
                        },
                        firstEvent: {
                            title: firstEvent.title !== meta.title ? firstEvent.title : '',
                            date: firstEvent.date,
                            startTime: firstEventStartTime,
                        },
                        isFavorite: favoriteChannels.includes(item.channel.id),
                    }),
                    schedule: item.schedule,
                    isFutureEvent: item.isFutureEvent,
                    scheduleViewStrategy: item.scheduleViewStrategy,
                    eventId: meta.eventId,
                    moreEvents: _get(item, 'optionsNextReq.more'),
                    onEventFinished: this._onEventFinished,
                    onMoreEvents: this._onMoreEvents,
                    metrika: {
                        orderIndex: i + 1,
                        programId: meta.programId,
                    },
                };
            }),
            isTouchButtons,
        };

        const {
            experiments,
            recommendedProvider,
        } = this.props;

        const {
            age,
            type,
            year,
            cover,
            title,
            posts,
            quotes,
            rating,
            awards,
            genres,
            isShow,
            reviews,
            persons,
            eventId,
            duration,
            programId,
            countries,
            isCartoon,
            personsMap,
            isFavorite,
            description,
            programCoId,
            canonicalUrl,
            originalTitle,
            mainReleaseDate,
            ottSelection,
        } = meta;

        const channelsId = this.props.program.schedules.map(item => _get(item, 'channel.familyId'));
        const trailer = _get(gallery, '0.video') && gallery[0];
        const hasTitle = gallery.length || persons.length || description || rating;
        const titleKey = (type.isFilm || type.isSerial) ? type.alias : 'program';
        const hasComplexHeader = Boolean(cover) && _get(description, 'length') > DESCRIPTION_LENGTH;
        const hasDescription = description && (!isLayoutColumnsSmall || !hasComplexHeader);
        const galleryItems = trailer && hasComplexHeader ? gallery.slice(1) : gallery;

        const programHeaderSimpleProps = {
            age,
            type,
            year,
            title,
            eventId,
            programId,
            channelsId,
            isFavorite,
            ottSelection,
            isLayoutColumnsSmall,
            buttonBroadcastingProps,
            episodesLength: episodes && episodes.length,
            onClickButtonEpisodes: this._onClickButtonEpisodes,
            onClickButtonWatchOnline: this._onClickButtonWatchOnline,
            onClickButtonWatchEpisode: this._onClickButtonWatchEpisode,
            onClickButtonBroadcasting: this._onClickButtonBroadcasting,
        };

        const programHeaderExtraProps = {
            cover,
            rating,
            trailer,
            countries,
            description,
            originalTitle,
            mainReleaseDate,
            genre: _get(genres, '0'),
            firstEvent: programHeaderEvent,
            onClickDescriptionButton: this._onClickDescriptionButton,
        };

        const programHeaderComplexProps = Object.assign({},
            programHeaderSimpleProps,
            programHeaderExtraProps
        );

        const programGalleryProps = {
            eventId,
            programId,
            items: galleryItems,
            programTitle: title,
            isLayoutColumnsSmall,
        };

        const programDescriptionProps = {
            mods: {
                type: 'content',
            },
            description,
            lineNumber: 5,
            lineHeight: 21,
        };

        const programStatisticsProps = {
            rating,
            awards,
            reviews,
            programCoId,
        };

        const programPersonsProps = {
            persons,
            isCartoon,
            programCoId,
            isLayoutColumnsSmall,
        };

        const programQuotesProps = {
            quotes,
            programCoId,
        };

        const programPostsProps = {
            posts,
            programCoId,
        };

        const programDetailsProps = {
            type,
            year,
            genres,
            isShow,
            duration,
            countries,
            personsMap,
        };

        const programOthersProps = {
            isLayoutColumnsSmall,
            titleKey: type.alias || titleKey,
            events: recommendedProvider.events || [],
            availableChannels: recommendedProvider.availableChannels,
            isLoading: !(recommendedProvider.events && recommendedProvider.events.length),
        };

        const advManagerAsideProps = {
            sticky: true,
            blockId: Global.adv.program_aside_desktop,
        };

        const advManagerFooterProps = {
            blockId: Global.adv[`program_footer_${this._isSerpApp ? 'serp_app' : advKey}`],
        };

        if (genres) {
            advManagerAsideProps.statId = STAT_ID;
            advManagerFooterProps.statId = STAT_ID;
        }

        const breadCrumbsProps = {
            items: [{title}],
        };

        const episodesProps = {
            episodes,
            canonicalUrl,
            hasComplexHeader,
            programId,
            channelsId,
            programType: type,
            programTitle: title,
            programDuration: duration,
            isLayoutColumnsLarge,
            isLayoutColumnsSmall,
            selectedEpisode,
            showModal: showEpisodesModal,
            onSelectEpisode: this._onClickEpisode,
        };

        const hasProgramEvent = programMultichannelsProps.schedules.some(schedule => Object.keys(schedule).length > 0);

        const resizeListenerProps = {
            callback: this._onResize,
        };

        const isExperimentZen = experiments.isExperiment(EXPERIMENT_ZEN) && Ua.isDesktop;

        let zenParams = {
            clid: 980,
            clid_name: 'zen_lib_tv_programma',
            lang: 'ru',
            uatraits: Ua.uatraits,
            apiName: 'launcher',
            product: 'zen_lib',
            partner: 'yandex',
            integration: 'zen_lib_tv_programma',
        };

        if (isADBEnabled(req)) {
            zenParams = Object.assign(zenParams, {
                host: 'https://main.zdevx.yandex.ru/',
                isAdblock: true,
            });
        }

        return (
            <Content className={bContent.mod({program: true})}>
                <div itemScope itemType="http://schema.org/Movie">
                    {hasComplexHeader && ([
                        <ProgramHeader_Complex key="program-header" {...programHeaderComplexProps} />,
                        <ProgramEpisodes key="program-episodes" ref={ref => (this._episodes = ref && ref.node)} {...episodesProps} />,
                    ])}
                    <div className={bContent('columns')}>
                        <div className={bContent('main')}>
                            {!hasComplexHeader && ([
                                <ProgramHeader_Simple key="program-header" {...programHeaderSimpleProps} />,
                                <ProgramEpisodes key="program-episodes" {...episodesProps} />,
                            ])}
                            {hasProgramEvent && (
                                <div className={b('schedules', {higher: hasComplexHeader})}>
                                    <ProgramMultichannels {...programMultichannelsProps} />
                                </div>
                            )}
                            {hasTitle && (
                                <h2
                                    ref={ref => (this._about = ref)}
                                    className={b('about')}
                                >
                                    {i18n.get(`program-controller.about-${titleKey}`)}
                                </h2>
                            )}
                            {galleryItems.length > 0 && (
                                <div className={b('gallery')}>
                                    <ProgramGallery {...programGalleryProps} />
                                </div>
                            )}
                            {hasDescription && (
                                <div className={b('description')}>
                                    <ProgramDescription
                                        ref={ref => (this._description = ref)}
                                        {...programDescriptionProps}
                                    />
                                </div>
                            )}
                            {rating && (
                                <div className={b('statistics')}>
                                    <ProgramStatistics {...programStatisticsProps} />
                                </div>
                            )}
                            {Ua.displayWidth && persons.length > 0 && genres && (
                                <div className={b('persons')}>
                                    <ProgramPersons {...programPersonsProps} />
                                </div>
                            )}
                            <div className={b('details')}>
                                <ProgramDetails {...programDetailsProps} />
                            </div>
                            {quotes && quotes.length > 0 && (
                                <div className={b('quotes')}>
                                    <ProgramQuotes {...programQuotesProps} />
                                </div>
                            )}
                            {posts && posts.length > 1 && (
                                <div className={b('posts')}>
                                    <ProgramPosts {...programPostsProps} />
                                </div>
                            )}
                            {recommendedRender && (
                                <div className={b('others')}>
                                    <ProgramOthers {...programOthersProps} />
                                </div>
                            )}
                            {[TABLET, PHONE].includes(advKey) && (
                                <div className={bContent('adv-footer')}>
                                    <AdvManager {...advManagerFooterProps} />
                                </div>
                            )}
                        </div>
                        <div className={bContent('adv-aside')}>
                            {advKey === DESKTOP && (
                                <AdvManager {...advManagerAsideProps} />
                            )}
                        </div>
                    </div>
                    {entryPoint && (
                        <div className={b('entry-point')}>
                            <ProgramEntryPoint {...entryPoint} />
                        </div>
                    )}
                    {advKey === DESKTOP && (
                        <div className={bContent('adv-footer')}>
                            <AdvManager {...advManagerFooterProps} />
                        </div>
                    )}
                </div>
                {isExperimentZen && <Zen params={zenParams}/>}
                <BreadCrumbs {...breadCrumbsProps} />
                <ResizeListener {...resizeListenerProps} />
            </Content>
        );
    }

    /**
     * @returns {Object}
     */
    get _initialState() {
        return {
            isTouchButtons: Ua.isTouchButtons,
            isLayoutColumnsSmall: Ua.isLayoutColumnsSmall,
            isLayoutColumnsLarge: Ua.isLayoutColumnsLarge,
            advKey: Ua.isLayoutColumnsSmall ? PHONE :
                Ua.isLayoutColumnsLarge ? TABLET : DESKTOP,
        };
    }

    /**
     * Запускаем прямой эфир
     * @private
     */
    _onClickButtonBroadcasting() {
        this._selectEpisode(null);
    }

    /**
     * Запускаем онлайн-просмотр
     * @private
     */
    _onClickButtonWatchOnline() {
        this._selectEpisode(null);
    }

    /**
     * Запускаем последний эпизод
     * @private
     */
    _onClickButtonWatchEpisode() {
        this._selectEpisode(this._latestEpisode);
    }

    /**
     * Открывает модалку с эпизодами
     * @private
     */
    _onClickButtonEpisodes() {
        this.setState({showEpisodesModal: true});
    }

    /**
     * Запускаем выбранный эпизод
     * @private
     */
    _onClickEpisode(episode) {
        this._selectEpisode(episode);
    }

    /**
     * Проставляет эпизод и скроллит
     * @private
     */
    _selectEpisode(episode) {
        if (!episode) {
            setTimeout(() => this.setState({
                selectedEpisode: episode,
                showEpisodesModal: false,
            }), 100);
        } else {
            this.setState({selectedEpisode: episode});
        }

        if (this._episodes) {
            window.scrollTo({
                behavior: 'smooth',
                left: 0,
                top: episode ? this._episodes.offsetTop : 0,
            });
        }
    }

    /**
     * Открываем описание
     * @private
     */
    _onClickDescriptionButton() {
        window.scrollTo({
            behavior: 'smooth',
            left: 0,
            top: this._about.offsetTop - SCROLL_OFFSET,
        });

        this._description.open();
    }

    /**
     * Передача в сетке закончилась — перезапрашиваем и перерисовываем сетку
     * @private
     */
    _onEventFinished() {
        const {
            meta,
            scheduleViewStrategy,
        } = this.props.program;
        const {programId, eventId} = meta;
        const moment = this.props.req.lib('moment');

        this.props.dispatchUpdateProgramSchedule({
            start: moment.toISO(),
            programId,
            eventId,
            scheduleViewStrategy,
            skipUploaded: this.state.currentIndex,
        });
    }

    /**
     * Добавляем события в сетку
     * @param {Number} index чанка
     * @param {Number} channelId
     * @private
     */
    _onMoreEvents(index, channelId) {
        const {
            meta,
            schedules,
        } = this.props.program;
        const {programId, eventId} = meta;

        const selectedChannelData = _find(schedules, ['channel.id', channelId]);

        const {optionsNextReq, scheduleViewStrategy} = selectedChannelData;

        this.setState({
            currentIndex: index + 1,
        });

        const params = {
            start: optionsNextReq.start,
            channelId,
            programId,
            eventId,
            scheduleViewStrategy,
        };

        const dispatchGetProgramSchedule = this.props.dispatchGetProgramSchedule(params).then(this.props.dispatchUpdateReminders);

        if (!this._isSerpApp) {
            dispatchGetProgramSchedule.then(this._dispatchFulfilledReminders);
        }
    }

    /**
     * @private
     */
    _dispatchFulfilledReminders() {
        const {
            program,
            userPhone,
            userLogged,
        } = this.props;

        if (userLogged && userPhone) {
            program.schedules.forEach(programSchedule => {
                const schedule = programSchedule.schedule;
                const items = Object.keys(schedule).reduce((total, date) => {
                    return total.concat(schedule[date].items);
                }, []);

                const eventIds = items.map(event => event.id);

                _chunk(eventIds, REMINDERS_CHUNK_SIZE).forEach(ids => this.props.dispatchFulfilledReminders(ids));
            });
        }
    }

    /**
     * Последний эпизод
     * @private
     * @returns {Object|null}
     */
    get _latestEpisode() {
        const {episodes} = this.props.program;

        return episodes && episodes[0];
    }

    /**
     * @private
     */
    _onResize() {
        this.setState({
            isTouchButtons: Ua.isTouchButtons,
            isLayoutColumnsSmall: Ua.isLayoutColumnsSmall,
            isLayoutColumnsLarge: Ua.isLayoutColumnsLarge,
        });
    }

}

ProgramController.propTypes = {
    program: PropTypes.shape({
        gallery: PropTypes.array.isRequired,
        meta: PropTypes.object.isRequired,
        schedules: PropTypes.array,
    }),
};

function mapStateToProps(state) {
    return {
        events: _get(state, 'event.items') || [],
        program: state.program,
        userLogged: state.user.isLogged,
        userPhone: state.user.phone,
        favoriteChannels: state.channel.favorites || [],
        recommendedProvider: state.recommendedProvider,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatchGetProgramSchedule: params => dispatch(getSchedule(params)),
        dispatchFulfilledReminders: eventIds => dispatch(fulfilledReminders(eventIds)),
        dispatchUpdateProgramSchedule: params => dispatch(updateSchedule(params)),
        dispatchGetFavoriteChannels: channelsIds => dispatch(getFavoriteChannels(channelsIds)),
        dispatchUpdateReminders: eventIds => dispatch(updateReminders(eventIds)),
        dispatchGetRecommended: (programId, programTypeId) => dispatch(getProvider(programId, programTypeId)),
    };
}

module.exports = connect(
    mapStateToProps,
    mapDispatchToProps
)(
    withReq(withI18n(withExperiments(
        ProgramController
    )))
);
